<script lang="ts">
    import HubButton from '$lib/components/Button/HubButton.svelte';
    import SearchIcon from '$lib/icons/search.svg';
    import HomeIcon from '$lib/icons/home.svg';
    import PromosIcon from '$lib/icons/promos.svg';
    import LiveIcon from '$lib/icons/liveCasino.svg';
    import SlotsIcon from '$lib/icons/slots.svg';
    import HallOfFameIcon from '$lib/icons/hallOfFame.svg';
    import type { TWordpressFabricCasinoHubTranslations } from '$lib/services/wordpress/types';
    import { CASINOHUB_TESTIDS } from './constants';
    import type { THubItem } from './types';
    import { getRoute, isActiveRoute } from '$lib/services/navigation';
    import ROUTE_IDS from '$generated/routeIds';
    import { scrollSelectedIntoView } from '$src/lib/actions/scrollSelectedIntoView';

    export let translations: TWordpressFabricCasinoHubTranslations;
    export let flags: { showFabricLobbies: boolean };
    export let isLoggedIn: boolean;

    const searchHref = getRoute(ROUTE_IDS.GAMES_SEARCH);
    const searchItemSelected = isActiveRoute(ROUTE_IDS.GAMES_SEARCH);
    $: searchItem = {
        href: searchHref,
        selected: $searchItemSelected,
        testid: CASINOHUB_TESTIDS.searchItem,
        Icon: SearchIcon
    } as THubItem;
    const homeItemHref = getRoute('/');
    const homeItemSelected = isActiveRoute('/');
    $: homeItem = {
        href: homeItemHref,
        selected: $homeItemSelected,
        testid: CASINOHUB_TESTIDS.homeItem,
        Icon: HomeIcon
    } as THubItem;
    const casinoGamesHref = getRoute('/casino-games');
    const casinoGamesSelected = isActiveRoute('/casino-games');
    $: casinoGames = {
        text: translations.games,
        href: casinoGamesHref,
        selected: $casinoGamesSelected,
        testid: CASINOHUB_TESTIDS.casinoGamesItem,
        Icon: SlotsIcon
    } as THubItem;
    const slotsHref = getRoute('/slots');
    const slotsSelected = isActiveRoute('/slots');
    $: slotsItem = {
        text: translations.slots,
        href: slotsHref,
        selected: $slotsSelected,
        testid: CASINOHUB_TESTIDS.slotsItem,
        Icon: SlotsIcon
    } as THubItem;
    const promotionsItemHref = getRoute('/promotions');
    const promotionsItemSelected = isActiveRoute('/promotions');
    $: promotionsItem = {
        text: translations.promotions,
        href: promotionsItemHref,
        selected: $promotionsItemSelected,
        testid: CASINOHUB_TESTIDS.promotionsItem,
        Icon: PromosIcon
    } as THubItem;
    const liveCasinoItemHref = getRoute('/live-casino');
    const liveCasinoItemSelected = isActiveRoute('/live-casino');
    $: liveCasinoItem = {
        text: translations.live,
        href: liveCasinoItemHref,
        selected: $liveCasinoItemSelected,
        testid: CASINOHUB_TESTIDS.liveCasinoItem,
        Icon: LiveIcon
    } as THubItem;
    const hallOfFameItemHref = getRoute(ROUTE_IDS.HALL_OF_FAME);
    const hallOfFameItemSelected = isActiveRoute(ROUTE_IDS.HALL_OF_FAME);
    $: hallOfFameItem = {
        text: translations.hall_of_fame,
        href: hallOfFameItemHref,
        selected: $hallOfFameItemSelected,
        testid: CASINOHUB_TESTIDS.hallOfFameItem,
        Icon: HallOfFameIcon
    } as THubItem;

    let hubItems: Array<THubItem>;
    $: if (flags.showFabricLobbies) {
        if (isLoggedIn) {
            hubItems = [
                searchItem,
                homeItem,
                slotsItem,
                liveCasinoItem,
                promotionsItem,
                hallOfFameItem
            ];
        } else {
            hubItems = [searchItem, homeItem, slotsItem, liveCasinoItem, promotionsItem];
        }
    } else {
        hubItems = [homeItem, casinoGames, liveCasinoItem, promotionsItem];
    }
</script>

<div
    class="sticky top-[var(--rg-height)] z-[10] w-full tablet:top-[var(--header-height)] tablet:z-[4]"
>
    <div class="flex bg-purple-80 p-sm px-0 desktop-l:p-md">
        <nav
            use:scrollSelectedIntoView={{ isLoaded: !!hubItems, selector: '.scroll-into-view' }}
            class="flex min-w-0 gap-2xs overflow-auto px-sm pb-[3px] scrollbar-none tablet:px-2xl desktop-l:px-md"
        >
            {#each hubItems as { selected, href, text, onClick, Icon, testid, hasNotification }}
                <HubButton {selected} {href} {text} {onClick} {testid} {hasNotification}>
                    <Icon slot="icon" class="h-md" />
                </HubButton>
            {/each}
        </nav>
    </div>
</div>
<slot />
